import React from "react";

import { CanvasArea } from "@v1/components/canvas/Canvas";
import { CanvasControls } from "@v1/components/canvas/CanvasControls";
import DraggingCursorFrame from "@v1/components/DraggingCursorFrame";
import LeftBar from "@v1/components/left-bar/LeftBar";
import RightBar from "@v1/components/right-bar/RightBar";
import { selectDraftElementId } from "@v1/reducers/core-reducer";
import { useEditorSelector } from "@v1/store/store";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";

import { EditorLayout } from "./EditorLayout";

type ElementEditorLayoutProps = React.PropsWithChildren;

const ElementEditorLayout = ({ children }: ElementEditorLayoutProps) => {
  const forDisplayingElementWithinEditor = (
    <>
      <DraggingCursorFrame />
      <CanvasWrapper />
    </>
  );

  const elementSpecificEditorOverlays = (
    <>
      <CanvasControls />
      <LeftBar showElementSpecificContent={true} />
      <RightBar />
    </>
  );

  return (
    <EditorLayout
      toRenderWithinEditor={forDisplayingElementWithinEditor}
      toRenderOverEditor={elementSpecificEditorOverlays}
    >
      {children}
    </EditorLayout>
  );
};

const CanvasWrapper = () => {
  const projectId = useCurrentProjectId();
  const elementId = useEditorSelector(selectDraftElementId);
  const isCanvasVisible = Boolean(projectId) && Boolean(elementId);
  return isCanvasVisible ? <CanvasArea /> : null;
};

export default ElementEditorLayout;
